// extracted by mini-css-extract-plugin
module.exports = {"loading":"_1a7df13","forwards":"_80a5415","backwards":"_8bea816","none":"_e5f50dc","full":"_d1df26d"};